interface PublicRiskBadgeProps {
  risco: string;
}

export function PublicRiskBadge({ risco }: PublicRiskBadgeProps) {
  const map: Record<string, { bg: string; text: string; icon: string }> = {
    "Baixo": { bg: "bg-primary-50", text: "text-primary-700", icon: "ri-checkbox-circle-line" },
    "Médio": { bg: "bg-caution-50", text: "text-caution-700", icon: "ri-information-line" },
    "Alto": { bg: "bg-warning-50", text: "text-warning-700", icon: "ri-alert-line" },
    "Crítico": { bg: "bg-danger-50", text: "text-danger-700", icon: "ri-error-warning-line" },
  };
  const style = map[risco] || map["Baixo"];
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${style.bg} ${style.text}`}>
      <i className={`${style.icon} w-3 h-3 flex items-center justify-center`} />
      {risco}
    </span>
  );
}

interface PublicStatusBadgeProps {
  status: string;
}

export function PublicStatusBadge({ status }: PublicStatusBadgeProps) {
  const map: Record<string, { bg: string; text: string }> = {
    "Em andamento": { bg: "bg-primary-50", text: "text-primary-700" },
    "Concluído": { bg: "bg-accent-50", text: "text-accent-700" },
    "Planejado": { bg: "bg-secondary-50", text: "text-secondary-700" },
    "Em revisão": { bg: "bg-warning-50", text: "text-warning-700" },
    "Publicado": { bg: "bg-primary-50", text: "text-primary-700" },
    "Bom": { bg: "bg-primary-50", text: "text-primary-700" },
    "Regular": { bg: "bg-warning-50", text: "text-warning-700" },
    "Ruim": { bg: "bg-danger-50", text: "text-danger-700" },
  };
  const style = map[status] || { bg: "bg-background-100", text: "text-foreground-600" };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${style.bg} ${style.text}`}>
      {status}
    </span>
  );
}

interface PublicProjectStatusBadgeProps {
  status: string;
}

export function PublicProjectStatusBadge({ status }: PublicProjectStatusBadgeProps) {
  const map: Record<string, { bg: string; text: string; icon: string }> = {
    "Planejado": { bg: "bg-secondary-50", text: "text-secondary-700", icon: "ri-time-line" },
    "Em andamento": { bg: "bg-primary-50", text: "text-primary-700", icon: "ri-play-circle-line" },
    "Em revisão": { bg: "bg-warning-50", text: "text-warning-700", icon: "ri-search-line" },
    "Concluído": { bg: "bg-accent-50", text: "text-accent-700", icon: "ri-checkbox-circle-line" },
    "Publicado": { bg: "bg-primary-50", text: "text-primary-700", icon: "ri-global-line" },
  };
  const style = map[status] || map["Planejado"];
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${style.bg} ${style.text}`}>
      <i className={`${style.icon} w-3 h-3 flex items-center justify-center`} />
      {status}
    </span>
  );
}